/**
 * @fileoverview Barra do estado da triagem na tela "Ordens de serviço": quantas OS
 * há em cada estado (com os outros filtros) e, num clique, só as daquele estado;
 * clicar de novo no escolhido, ou em "Todas", volta a mostrar todas.
 */

import React from "react";

import { i18n } from "../../translate/i18n";
import { triageStateLabel, triageStateTone } from "./triageState";

const t = (key) => i18n.t(`workOrders.triageFilter.${key}`);

const TriageStateBar = ({ classes, counts, value, onChange }) => {
  const total = counts.reduce((sum, c) => sum + c.count, 0);
  // O escolhido continua na barra mesmo sem OS (ex.: a última foi concluída).
  const items = value && !counts.some((c) => c.value === value) ? [...counts, { value, count: 0 }] : counts;
  const chip = (on) => `${classes.stateChip} ${on ? classes.stateChipOn : ""}`;

  return (
    <div className={classes.stateBar} role="group" aria-label={t("label")}>
      <span className={classes.stateBarLabel} aria-hidden="true">
        {t("label")}
      </span>
      <button type="button" className={chip(!value)} aria-pressed={!value} onClick={() => onChange("")}>
        {t("all")}
        <span className={classes.stateCount}>{total}</span>
      </button>
      {items.map((c) => (
        <button
          key={c.value}
          type="button"
          className={chip(value === c.value)}
          aria-pressed={value === c.value}
          onClick={() => onChange(value === c.value ? "" : c.value)}
        >
          <span className={`${classes.stateDot} ${classes[`dot_${triageStateTone(c.value)}`]}`} aria-hidden="true" />
          {triageStateLabel(c.value)}
          <span className={classes.stateCount}>{c.count}</span>
        </button>
      ))}
    </div>
  );
};

export default TriageStateBar;
